import { Component, Toggle, _decorator } from 'cc';
import MultiThemeSource from '../MultiTheme/MultiThemeSource';

const { ccclass, requireComponent, executeInEditMode } = _decorator;

@ccclass('ToggleMultiTheme')
@executeInEditMode
@requireComponent([MultiThemeSource, Toggle])
export default class ToggleMultiTheme extends Component {
    protected onLoad(): void {
        const multiThemeSource = this.getComponent(MultiThemeSource);
        const toggle = this.getComponent(Toggle);
        toggle.node.on(Toggle.EventType.TOGGLE, () => {
            multiThemeSource.theme = toggle.isChecked ? 1 : 0;
        });
        multiThemeSource.theme = toggle.isChecked ? 1 : 0;
    }
}
